import React from 'react';
import { FormControl, MenuItem, Avatar, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import ptImage from 'assets/pt.png';
import enImage from 'assets/en.png';
import esImage from 'assets/es.png';
import i18n from 'locales/i18n';
import { languageAtom } from 'atoms';
import TopBarSelect from 'components/TopBarSelect';

export const LANGUAGES: { [key: string]: { image: string; text: string } } = {
  pt: { image: ptImage, text: 'Português' },
  en: { image: enImage, text: 'English' },
  es: { image: esImage, text: 'Español' },
};

function LanguageSelect() {
  const [language, setLanguage] = useRecoilState(languageAtom);

  return (
    <FormControl>
      <TopBarSelect
        aria-label="Lingua"
        id="language-select"
        value={language}
        label="lingua"
        onChange={(e) => {
          setLanguage(e.target.value);
          i18n.changeLanguage(e.target.value);
        }}
        renderValue={(value: string) => {
          const lang = LANGUAGES[value.slice(0, 2)];
          return <Avatar src={lang.image} alt={lang.text} sx={{ width: 35, height: 35 }} />;
        }}
      >
        {Object.entries(LANGUAGES).map(([lang, { image, text }]) => (
          <MenuItem key={lang} value={lang}>
            <Avatar src={image} alt={text} sx={{ width: 35, height: 35 }} />
            <Typography variant="body2" sx={{ ml: 1.5 }}>
              {text}
            </Typography>
          </MenuItem>
        ))}
      </TopBarSelect>
    </FormControl>
  );
}

export default LanguageSelect;
